import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=3608ea56&"
import script from "./videoDialog.vue?vue&type=script&lang=js&"
export * from "./videoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports